import { useState } from "react";
import { ShoppingBag, ChevronDown } from "lucide-react";
import { priceLabel, money } from "../../data/catalog";

const badge = (l) =>
  l.grade === 10 ? "bg-volt text-black" : l.grade === 9 ? "bg-cyanx text-black" : l.grade ? "bg-black/60 text-white border border-white/20 backdrop-blur" : "bg-bolt text-white";

const Stock = ({ n }) => (
  <span className={`font-mono text-[11px] uppercase tracking-[0.18em] ${n > 0 ? "text-volt" : "text-red-400"}`}>
    {n > 0 ? `${n} in stock` : "Sold out"}
  </span>
);

export const ProductCard = ({ l, live }) => {
  const variations = Array.isArray(l.variations) ? l.variations : [];
  const [sel, setSel] = useState("");
  const current = variations.find((v) => v.id === sel);
  const stock = current ? current.available : l.available;
  const soldOut = live && stock === 0;
  const spot = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    e.currentTarget.style.setProperty("--x", `${e.clientX - r.left}px`);
    e.currentTarget.style.setProperty("--y", `${e.clientY - r.top}px`);
  };
  return (
    <article onMouseMove={spot} className="product-card group relative flex h-full flex-col overflow-hidden rounded-[24px] border border-white/10 bg-[#0F121A]" data-testid={`product-card-${l.id}`}>
      <div className="relative aspect-[3/4] overflow-hidden bg-black">
        <img src={current?.image ?? l.image} alt={l.title} loading="lazy" className="h-full w-full object-cover object-top transition-transform duration-[1s] ease-out group-hover:scale-[1.06]" />
        <span className={`absolute left-4 top-4 rounded-full px-3 py-1 font-mono text-[11px] font-bold uppercase tracking-widest ${badge(l)}`}>
          {l.grade ? `ACE ${l.grade} · ${l.label}` : l.label}
        </span>
      </div>
      <div className="relative z-10 flex flex-1 flex-col gap-4 p-5">
        <div>
          <h3 className="font-display text-xl font-bold leading-tight">{l.title}</h3>
          <div className="mt-2 flex items-center justify-between gap-2">
            <span className="font-display text-lg font-extrabold" data-testid={`product-price-${l.id}`}>{current ? money(current.price) : priceLabel(l)}</span>
            {live && <Stock n={stock} />}
          </div>
        </div>
        {variations.length > 1 && (
          <label className="relative block">
            <span className="sr-only">Choose your card</span>
            <select value={sel} onChange={(e) => setSel(e.target.value)} className="w-full appearance-none rounded-xl border border-white/15 bg-[#151925] py-3 pl-4 pr-10 text-base text-white focus:border-volt focus:outline-none" data-testid={`product-variation-${l.id}`}>
              <option value="">Choose your card ({variations.length})</option>
              {variations.map((v) => (
                <option key={v.id} value={v.id} disabled={v.available === 0}>{v.name} — {money(v.price)}{v.available === 0 ? " (sold)" : ""}</option>
              ))}
            </select>
            <ChevronDown className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
          </label>
        )}
        {soldOut ? (
          <span className="mt-auto rounded-full border border-white/10 py-3 text-center text-sm font-semibold text-slate-400" data-testid={`product-soldout-${l.id}`}>Sold out</span>
        ) : (
          <a href={current?.url ?? l.url} target="_blank" rel="noopener noreferrer" className="btn-primary group/btn mt-auto justify-center" data-testid={`product-order-${l.id}`}>
            <ShoppingBag className="h-4 w-4" /> {current ? "Order this card" : "Order now"}
          </a>
        )}
      </div>
    </article>
  );
};
